"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var deep_equals_1 = require("./deep-equals");
__export(require("./deep-equals"));
function deepEquals(actual, expected, opts) {
    var result = deep_equals_1.deepEquals(actual, expected, [], opts);
    if (result instanceof Error) {
        // Keep the stack trace short and sweet
        throw Error(result.message);
    }
    return true;
}
exports.default = deepEquals;
exports.deepEquals = deepEquals;
